'use client';

import { motion } from 'framer-motion';
import Image from 'next/image';

export default function HomePage() {
  return (
    <main className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Hero Background */}
      <div className="absolute inset-0 z-0">
        <Image
          src="/images/uploads/3a2e706a-a697-4dcf-b75e-c58c5f630a3e.jpg"
          alt="Shark Hunters tactical team"
          fill
          className="object-cover"
          priority
        />
        {/* Dark overlay for better text readability */}
        <div className="absolute inset-0 bg-black/40" />
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-4">
        {/* Tagline */}
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.2 }}
          className="mb-8"
        >
          <p className="font-mono text-sm md:text-base lg:text-lg text-emerald-400 font-bold tracking-[0.3em] uppercase drop-shadow-[0_0_10px_rgba(52,211,153,0.5)]">
            SharkHunters: hunting the whales, not swimming with them
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="mb-12"
        >
          <h1 className="font-display text-6xl md:text-8xl font-bold text-white mb-6 drop-shadow-2xl">
            SHARK HUNTERS
          </h1>
          <p className="text-xl md:text-2xl text-white/90 font-medium drop-shadow-lg">
            Join the Movement
          </p>
        </motion.div>

        {/* Social Links */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
          className="flex items-center justify-center gap-6"
        >
          {/* Telegram Button */}
          <a
            href="https://t.me/+3tD19y67_scxZGE0"
            target="_blank"
            rel="noopener noreferrer"
            className="group relative"
          >
            <div className="relative w-20 h-20 md:w-24 md:h-24 rounded-xl overflow-hidden border-2 border-white/30 hover:border-white transition-all duration-300 hover:scale-110 hover:shadow-2xl">
              <Image
                src="/images/generated/icon-telegram-tactical.png"
                alt="Telegram"
                fill
                className="object-cover"
              />
            </div>
            <span className="absolute -bottom-8 left-1/2 -translate-x-1/2 text-white text-sm font-medium opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
              Telegram
            </span>
          </a>

          {/* Discord Button */}
          <a
            href="https://discord.gg/6vMKXKdT"
            target="_blank"
            rel="noopener noreferrer"
            className="group relative"
          >
            <div className="relative w-20 h-20 md:w-24 md:h-24 rounded-xl overflow-hidden border-2 border-white/30 hover:border-white transition-all duration-300 hover:scale-110 hover:shadow-2xl">
              <Image
                src="/images/generated/discord-logo-icon-tactical.png"
                alt="Discord"
                fill
                className="object-cover"
              />
            </div>
            <span className="absolute -bottom-8 left-1/2 -translate-x-1/2 text-white text-sm font-medium opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
              Discord
            </span>
          </a>

          {/* Twitter Button */}
          <a
            href="https://x.com/SharkHunters121"
            target="_blank"
            rel="noopener noreferrer"
            className="group relative"
          >
            <div className="relative w-20 h-20 md:w-24 md:h-24 rounded-xl overflow-hidden border-2 border-white/30 hover:border-white transition-all duration-300 hover:scale-110 hover:shadow-2xl">
              <Image
                src="/images/generated/icon-twitter-tactical.png"
                alt="Twitter"
                fill
                className="object-cover"
              />
            </div>
            <span className="absolute -bottom-8 left-1/2 -translate-x-1/2 text-white text-sm font-medium opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
              Twitter
            </span>
          </a>
        </motion.div>

        {/* Contact Email */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.6 }}
          className="mt-16 text-center"
        >
          <a
            href="mailto:contact@sharkhunters.com"
            className="text-white/80 hover:text-white text-lg font-medium transition-colors duration-300 underline decoration-white/30 hover:decoration-white"
          >
            contact@sharkhunters.com
          </a>
        </motion.div>
      </div>
    </main>
  );
}
